import React, { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { CustomSelect, FilterOptions, GradeOptions, StudentSexOptions } from "../../../../../../_helpers/Helpers";
import * as actions from "../../../_redux/advisors/AdvisorsAction";
import { useAdvisorsUIContext } from "../AdvisorsUIContext";

const prepareFilter = (queryParams, values) => {
  const { term, teacherId, studentName, studentSurname, grade, section, sex } = values;
  const newQueryParams = { ...queryParams };
  const filter = { teacherId, studentName, studentSurname, grade, section, sex };
  newQueryParams.filter = filter;
  newQueryParams.term = term;
  return newQueryParams;
};

export function AdvisorsFilter() {
  // Advisors UI Context
  const advisorsUIContext = useAdvisorsUIContext();
  const advisorsUIProps = useMemo(() => {
    return {
      setQueryParams: advisorsUIContext.setQueryParams,
      queryParams: advisorsUIContext.queryParams,
    };
  }, [advisorsUIContext]);

  const dispatch = useDispatch();
  const { currentActiveTerm, teachers } = useSelector(
    (state) => ({
      currentActiveTerm: state.auth.user.currentActiveTerm,
      teachers: state.advisors.teachers
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.getTeachers(currentActiveTerm));
  }, [currentActiveTerm, dispatch]);
  
  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(advisorsUIProps.queryParams, values);
    if (!isEqual(newQueryParams, advisorsUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      advisorsUIProps.setQueryParams(newQueryParams);
    }
  };
  
  const teacherOptions = FilterOptions.concat(teachers);
  const gradeOptions = FilterOptions.concat(GradeOptions);
  const sexOptions = FilterOptions.concat(StudentSexOptions);

  return (
    <Formik
      initialValues={{
        term: currentActiveTerm,
        studentName: "",
        studentSurname: "",
        section: ""
      }}
      onSubmit={(values) => {
        applyFilter(values);
      }}
    >
      {({
        values,
        handleSubmit,
        handleBlur,
        handleChange,
        setFieldValue,
      }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <div className="form-group row">
            <div className="col-sm-2"></div>
            <label className="form-label col-form-label col-sm-1">
              Dönem
            </label>
            <div className="col-sm-2">
              <input
                type="number" 
                className="form-control"
                min={1}
                value={values.term}
                id="term"
                placeholder="Dönem"
                onBlur={handleBlur}
                onChange={e => {
                  handleChange(e);
                  handleChange("term2")(e);
                  handleSubmit();
                  dispatch(actions.getTeachers(e.target.value));
                }}
              />
            </div>
            <div className="col-sm-2">
              <input className="form-control" value={values.term + 1} id="term2" readOnly />
            </div>
          </div>

          <div className="form-group row">
            <div className="col-lg-2">
              <CustomSelect 
                options={teacherOptions}
                value={values.teacherId}
                placeholder="Öğretmen"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("teacherId", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Öğretmen</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="studentName"
                placeholder="Öğrenci Adı"
                onBlur={handleBlur}
                value={values.studentName}
                onChange={(e) => {
                  setFieldValue("studentName", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Öğrenci Adı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="studentSurname"
                placeholder="Öğrenci Soyadı"
                onBlur={handleBlur}
                value={values.studentSurname}
                onChange={(e) => {
                  setFieldValue("studentSurname", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Öğrenci Soyadı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <CustomSelect 
                options={gradeOptions}
                value={values.grade}
                placeholder="Sınıfı"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("grade", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Sınıfı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="section"
                placeholder="Şube"
                onBlur={handleBlur}
                value={values.section}
                onChange={(e) => {
                  setFieldValue("section", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Şube</b>
              </small>
            </div>
            <div className="col-lg-2">
              <CustomSelect 
                options={sexOptions}
                value={values.sex}
                placeholder="Cinsiyeti"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("sex", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Cinsiyeti</b>
              </small>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
}